const sizeScale = {
    default: 0,
    sm: 1,
    md: 2,
    lg: 3,
};
const emptyArray = Array.from(new Array(5));
function upTo(size) {
    const sizeIdx = sizeScale[size];
    return (firstVal, secondVal) => {
        return emptyArray.reduce((acc, _, i) => {
            if (i > sizeIdx) {
                return [...acc, secondVal];
            }
            return [...acc, firstVal];
        }, []);
    };
}
/**
 * Returns an array with only the default breakpoint value set.
 */
export const upToDefault = upTo('default');
/**
 * Returns an array with all values up to the SM breakpoint value set.
 */
export const upToSm = upTo('sm');
/**
 * Returns an array with all values up to the MD breakpoint value set.
 */
export const upToMd = upTo('md');
/**
 * Returns an array with all values up to the LG breakpoint value set.
 */
export const upToLg = upTo('lg');
const sortCustomArray = (a, b) => {
    const [aKey] = a;
    const [bKey] = b;
    const aOrder = sizeScale[aKey];
    const bOrder = sizeScale[bKey];
    return aOrder - bOrder;
};
const reduceSizeValues = (acc, [key, value], i, customSizesArr) => {
    var _a;
    const sizeIdx = sizeScale[key];
    const nextKey = (_a = customSizesArr[i + 1]) === null || _a === void 0 ? void 0 : _a[0];
    const nextSizeIdx = nextKey ? sizeScale[nextKey] : 0;
    const isFinalValue = sizeIdx === 4;
    const isLastArrValue = i === customSizesArr.length - 1;
    const isFinalValueSkipped = isLastArrValue && !isFinalValue;
    const distance = isFinalValueSkipped ? 5 - sizeIdx : nextSizeIdx - sizeIdx;
    const areNextValuesSkipped = distance > 1;
    if (areNextValuesSkipped) {
        const filledValues = Array.from(new Array(distance)).fill(value);
        return [...acc, ...filledValues];
    }
    return [...acc, value];
};
export const upToCustom = (sizeOpts) => {
    const initialValue = [];
    return Object.entries(sizeOpts)
        .sort(sortCustomArray)
        .reduce(reduceSizeValues, initialValue);
};
//# sourceMappingURL=index.js.map